import React, { useState } from "react";
import { SubjectView } from "../../firestore/Types/SubjectSchema";
import { getAllSubjects } from "../../firestore/Functions/subjectFunctions";
import { getAllSchools } from "../../firestore/Functions/schoolFunctions";
import { SchoolView } from "../../firestore/Types/SchoolSchema";
import { getSchoolImageURL } from "../../firebase/storage/SchoolFunction";
import { UserProfileView } from "../../firestore/Types/UserProfileSchema";
import { getAllUserProfiles } from "../../firestore/Functions/accountFunctions";
import { config } from '@fortawesome/fontawesome-svg-core'
import '@fortawesome/fontawesome-svg-core/styles.css'
import { ToastArea, ToastMessage } from "../../components/Toasts/ToastArea";
config.autoAddCss = false;

export type SchoolImages = {
    SchoolId: string;
    Image: string;
}

const utilityContext = React.createContext(
    {
        subjects: [] as SubjectView[],
        schools: [] as SchoolView[],
        schoolImages: [] as SchoolImages[],
        userProfiles: [] as UserProfileView[],
        setNewToast: (toast: ToastMessage) => { },
    }
);

export function useUtility() {
    return React.useContext(utilityContext);
}

export function UtilityProvider({ children }: { children: React.ReactNode }) {
    const [subjects, setSubjects] = useState([] as SubjectView[]);
    const [schools, setSchools] = useState([] as SchoolView[]);
    const [schoolImages, setSchoolImages] = useState([] as SchoolImages[]);
    const [userProfiles, setUserProfiles] = useState([] as UserProfileView[]);
    const [toasts, setToasts] = useState([] as ToastMessage[]);

    function setNewToast(toast: ToastMessage) {
        setToasts([...toasts, toast]);
        setTimeout(() => {
            const newToasts = toasts.filter(t => t !== toast);
            setToasts([...newToasts]);
        }, 5000);
    }

    async function initializeSubjects() {
        const subjects = await getAllSubjects();
        setSubjects(subjects);
    }

    async function initializeSchools() {
        const schools = await getAllSchools();
        const schoolImages: SchoolImages[] = [];
        schools.forEach(async school => {
            const imgUrl = await getSchoolImageURL(school.Id);
            schoolImages.push({ SchoolId: school.Id, Image: imgUrl });
        });
        setSchoolImages(schoolImages);
        setSchools(schools);
    }

    async function initializeUserProfiles() {
        const profiles = await getAllUserProfiles();
        setUserProfiles(profiles);
    }

    React.useEffect(() => {
        initializeSubjects();
        initializeSchools();
        initializeUserProfiles();
    }, []);

    return (
        <utilityContext.Provider value={{ subjects, schools, schoolImages, userProfiles, setNewToast }}>
            <ToastArea toastMessages={toasts} setToastMessages={setToasts} />
            {children}
        </utilityContext.Provider>
    );
}